/**
 * Formats a number or string into a currency-like format with thousands separators.
 * If the value is empty, null, or undefined, it returns an empty string or the default value.
 * @param {number|string} value
 * @returns {string} Formatted number
 */
export const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(value);
  if (isNaN(num)) return value; // Return original if not a number
  return num.toLocaleString('en-US');
};

/**
 * Parses Arabic numerals to standard English numerals.
 * Useful for handling input change events where users might type with Arabic keyboards.
 * @param {string|number} value
 * @returns {string} Standardized numerical string
 */
export const parseArabicToEnglish = (value) => {
  if (value === null || value === undefined) return '';
  
  const str = String(value);
  const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  
  return str.replace(/[٠-٩]/g, (match) => {
    return arabicNumbers.indexOf(match);
  });
};
